import React, { useState, useEffect, useMemo } from "react";
import GlobalNavBar from "../shared/globalNavBar/GlobalNavBar";
import { withTranslation } from "react-i18next";
import Footer from "../shared/Footer/Footer";
import Crc from "./pure/Crc";
import withIdleTimer from "../common/WithIdleTimer";
import { Route, Router } from "react-router-dom";
import ErrorScreen from "../errors/ErrorScreen";
import Help from "../components/help/help";
import SearchWrapper from "../components/search/searchWrapper/SearchWrapper";
import OrdersSearch from "../components/search/searchWrapper/orders/OrdersSearch";

function CRCApp({ userDetails, history, ...props }) {
  const [padding, setPaddingState] = useState("70px");
  const [renderApp, setRenderApp] = useState(false);

  const currentCrc = useMemo(() => {
    return new Crc(userDetails, history);
  }, [userDetails, history]);

  useEffect(() => {
    history.push("/");
    setRenderApp(true);
  }, [history]);

  const setPadding = (padding) => {
    if (padding > 70) {
      setPaddingState(padding + "px");
    }
  };

  return (
    renderApp && (
      <Router history={history}>
        <div className="appWrapper">
          <div style={{ paddingTop: padding }}>
            <GlobalNavBar
              {...props}
              userDetails={userDetails}
              history={history}
              urlPath={window.location.pathname}
              setPadding={setPadding}
              user={currentCrc}
            />
          </div>

          <Route
            exact
            path="/"
            component={withIdleTimer(() => (
              <SearchWrapper
                {...props}
                userDetails={userDetails}
                history={history}
                user={currentCrc}
              />
            ))}
          />

          <Route
            exact
            path="/search"
            component={withIdleTimer(() => (
              <SearchWrapper
                {...props}
                userDetails={userDetails}
                history={history}
                user={currentCrc}
              />
            ))}
          />

          <Route
            exact
            path="/search/orders"
            component={withIdleTimer(() => (
              <OrdersSearch
                {...props}
                userDetails={userDetails}
                history={history}
                user={currentCrc}
              />
            ))}
          />

          <Route
            exact
            path="/error"
            render={(routeProps) => <ErrorScreen {...routeProps} />}
          />

          <Route
            exact
            path="/help"
            component={withIdleTimer(() => (
              <Help
                {...props}
                userDetails={userDetails}
                history={history}
                market={currentCrc.market}
              />
            ))}
          />

          <Footer permissions={userDetails.permissions} />
        </div>
      </Router>
    )
  );
}

export default withTranslation("emp")(CRCApp);
